module.exports = __webpack_public_path__ + "static/media/outlet.9dde6a1f.svg";